var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-row",
        { staticStyle: { "min-width": "1500px", "min-height": "800px" } },
        [
          _c(
            "a-col",
            { staticClass: "params-form", attrs: { span: "8" } },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: "3" } },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.lookIndex },
                        },
                        [_vm._v("返回")]
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: "21" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        staticStyle: { "margin-top": "8px" },
                      },
                      [_vm._v(" 农产品查询 ")]
                    ),
                  ]),
                ],
                1
              ),
              _c("a-divider"),
              _c(
                "a-row",
                [
                  _c(
                    "a-space",
                    [
                      _c("span", [_vm._v("搜索")]),
                      _c("a-input", {
                        staticStyle: { width: "300px" },
                        model: {
                          value: _vm.form.searchInput,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "searchInput", $$v)
                          },
                          expression: "form.searchInput",
                        },
                      }),
                      _c("a-button", { on: { click: _vm.searchTable } }, [
                        _vm._v("搜索"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [_c("a-col", [_c("div", { staticStyle: { height: "20px" } })])],
                1
              ),
              _c(
                "a-row",
                [
                  _c("a-ext-field-check-box", {
                    model: {
                      value: _vm.form.fields,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fields", $$v)
                      },
                      expression: "form.fields",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-row",
                [_c("a-col", [_c("div", { staticStyle: { height: "20px" } })])],
                1
              ),
              _c(
                "a-row",
                [
                  _c("a-table", {
                    attrs: {
                      rowKey: function (record) {
                        return record.id
                      },
                      columns: _vm.columns,
                      "data-source": _vm.tableData,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "type",
                        fn: function (text, record) {
                          return [
                            record.needJudge == "是"
                              ? _c("div", {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "16px",
                                    height: "16px",
                                    "background-color": "green",
                                    "border-radius": "8px",
                                  },
                                })
                              : _c("div", {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "16px",
                                    height: "16px",
                                    "background-color": "orange",
                                    "border-radius": "8px",
                                  },
                                }),
                          ]
                        },
                      },
                      {
                        key: "fullName",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectNode(record)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(text + "(" + record.path + ")"))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { staticClass: "params-form", attrs: { span: "5" } },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(" 农产品分类 "),
                  _vm.publishStatus === "未发布"
                    ? _c("a-button", {
                        attrs: {
                          type: "dashed",
                          shape: "circle",
                          icon: "plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onAddProduceItemModalOpen("1")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("a-divider"),
              _c(
                "div",
                { ref: "produceTree", staticClass: "overflowDiv" },
                [
                  _c("a-tree", {
                    attrs: {
                      "show-line": true,
                      "show-icon": false,
                      "tree-data": _vm.treeData,
                      title: { title: "title" },
                      expandedKeys: _vm.expandedKeys,
                      selectedKeys: _vm.selectedKeys,
                    },
                    on: {
                      "update:expandedKeys": function ($event) {
                        _vm.expandedKeys = $event
                      },
                      "update:expanded-keys": function ($event) {
                        _vm.expandedKeys = $event
                      },
                      "update:selectedKeys": function ($event) {
                        _vm.selectedKeys = $event
                      },
                      "update:selected-keys": function ($event) {
                        _vm.selectedKeys = $event
                      },
                      select: _vm.initForm,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title_green",
                        fn: function (item) {
                          return [
                            _c(
                              "p",
                              [
                                _c(
                                  "a-space",
                                  [
                                    _c("span", {
                                      staticStyle: {
                                        display: "inline-block",
                                        width: "16px",
                                        height: "16px",
                                        "background-color": "green",
                                        "border-radius": "8px",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          "line-height": "16px",
                                          "font-size": "14px",
                                          "font-weight": "700",
                                          color: "#7c7c7c",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    _vm.publishStatus === "未发布"
                                      ? _c("a-button", {
                                          attrs: {
                                            size: "small",
                                            type: "link",
                                            icon: "plus",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAddProduceItemModalOpen(
                                                item.path
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.publishStatus === "未发布"
                                      ? _c("a-button", {
                                          attrs: {
                                            size: "small",
                                            type: "link",
                                            icon: "close",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDelProduceItem(
                                                item.path
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "title_orange",
                        fn: function (item) {
                          return [
                            _c(
                              "p",
                              [
                                _c(
                                  "a-space",
                                  [
                                    _c("span", {
                                      staticStyle: {
                                        display: "inline-block",
                                        width: "16px",
                                        height: "16px",
                                        "background-color": "orange",
                                        "border-radius": "8px",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          "line-height": "16px",
                                          "font-size": "14px",
                                          "font-weight": "700",
                                          color: "#7c7c7c",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    _vm.publishStatus === "未发布"
                                      ? _c("a-button", {
                                          attrs: {
                                            size: "small",
                                            type: "link",
                                            icon: "plus",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAddProduceItemModalOpen(
                                                item.path
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.publishStatus === "未发布"
                                      ? _c("a-button", {
                                          attrs: {
                                            size: "small",
                                            type: "link",
                                            icon: "close",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDelProduceItem(
                                                item.path
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { staticClass: "params-form", attrs: { span: "10" } },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(" 农产品分类详情 "),
                  _vm.publishStatus === "未发布"
                    ? _c("a-button", {
                        attrs: {
                          type: "dashed",
                          shape: "circle",
                          icon: "save",
                        },
                        on: { click: _vm.handleOk },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("a-divider"),
              _c(
                "a-form-model",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.formState,
                    rules: _vm.rules,
                    "label-col": { span: 8 },
                    "wrapper-col": { span: 16 },
                  },
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "编号",
                                prop: "code",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "code", $$v)
                                  },
                                  expression: "formState.code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "是否参与判定标准",
                                prop: "needJudge",
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.formState.needJudge,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formState, "needJudge", $$v)
                                    },
                                    expression: "formState.needJudge",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "是" } }, [
                                    _vm._v(" 是 "),
                                  ]),
                                  _c("a-radio", { attrs: { value: "否" } }, [
                                    _vm._v(" 否 "),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "中文名称",
                                prop: "cn",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.cn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "cn", $$v)
                                  },
                                  expression: "formState.cn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "英文名称",
                                prop: "en",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.en,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "en", $$v)
                                  },
                                  expression: "formState.en",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "拉丁名称",
                                prop: "ld",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.ld,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "ld", $$v)
                                  },
                                  expression: "formState.ld",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "中文别名",
                                prop: "nick",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.nick,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "nick", $$v)
                                  },
                                  expression: "formState.nick",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "GEMS编码",
                                prop: "gems",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.gems,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "gems", $$v)
                                  },
                                  expression: "formState.gems",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "FOODEX_2编码",
                                prop: "foodex2",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.foodex2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "foodex2", $$v)
                                  },
                                  expression: "formState.foodex2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "照片",
                                prop: "zhaopian",
                              },
                            },
                            [
                              _c("a-ext-upload", {
                                model: {
                                  value: _vm.formState.zhaopian,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "zhaopian", $$v)
                                  },
                                  expression: "formState.zhaopian",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "描述",
                                prop: "remark",
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.formState.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "remark", $$v)
                                  },
                                  expression: "formState.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                                label: "所属行业",
                                prop: "hangye",
                              },
                            },
                            [
                              _c("a-ext-local-dic-select", {
                                attrs: { "dic-key": "HangYe" },
                                model: {
                                  value: _vm.formState.hangye,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "hangye", $$v)
                                  },
                                  expression: "formState.hangye",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.addProduceItemModalVisable
        ? _c("add-produce-item", {
            attrs: {
              visible: _vm.addProduceItemModalVisable,
              param: _vm.addProduceItemModalParam,
            },
            on: {
              "update:visible": function ($event) {
                _vm.addProduceItemModalVisable = $event
              },
              addStdProduceModalClose: _vm.onStdProduceItemModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }